// UTF-8-safe base64 encoder, mirroring the prop shape returned by the v3
// artifacts API. Used when we need to round-trip text through the
// `artifactContents` map (e.g. seeding a draft markdown artifact).
const encodeBase64 = (text: string): string => {
  const bytes = new TextEncoder().encode(text);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
};

export default encodeBase64;
